import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-full max-w-xl max-h-full z-50" }
const _hoisted_2 = { class: "relative bg-white rounded-lg shadow" }
const _hoisted_3 = {
  class: "p-6 flex flex-col w-full",
  "data-testid": "test-cancel-tour"
}
const _hoisted_4 = { class: "text-red-500" }
const _hoisted_5 = { class: "py-3 flex flex-wrap justify-center gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyTravelLarge = _resolveComponent("MyTravelLarge")!
  const _component_DbButton = _resolveComponent("DbButton")!

  return (_openBlock(), _createElementBlock("div", {
    id: "counter-cancellation-needed-modal",
    class: _normalizeClass([_ctx.visible ? 'flex' : 'hidden', "fixed top-0 left-0 right-0 bottom-0 px-5 flex items-center justify-center z-50"]),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MyTravelLarge, { color: "red" }),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("tour.counter_cancellation_needed")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DbButton, {
            onOnClick: _ctx.close,
            class: "hydrated button-gap",
            variant: "secondary-solid"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("order.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onOnClick"]),
          _createVNode(_component_DbButton, {
            onOnClick: _ctx.submit,
            class: "hydrated px-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("order.discard_task")), 1)
            ]),
            _: 1
          }, 8, ["onOnClick"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      "modal-backdrop": "",
      class: _normalizeClass([_ctx.visible ? 'flex' : 'hidden', "bg-gray-900 bg-opacity-50 fixed inset-0 z-40"])
    }, null, 2)
  ], 2))
}